<template>
<div>
  <div class='h-dialogContainer'>
    <div class='col-sm-6 h-col-inputBox'>
      <div class='h-inputLit'>{{$ts("Spectrum.ui_Duration")}}</div>
      <ejs-dropdownlist id="float" :fields = "fields" :index = "currentIndex" :dataSource = "items" :popupHeight= "popupHeight" v-model='durationValue'>
      </ejs-dropdownlist>
    </div>
    <div class='col-sm-6 h-col-inputBox'>
      <div class='h-inputLit row'>{{$ts('Spectrum.ui_cycle')}}</div>
      <form>
          <div class="row"><ejs-radiobutton :label='$ts("Spectrum.ui_pt_spectrum1s")' name="cycle" value="0" checked="true" ></ejs-radiobutton></div>
          <div class="row"><ejs-radiobutton :label='$ts("Spectrum.ui_pt_spectrum2s")' name="cycle" value="1" ></ejs-radiobutton></div>
          <div class="row"><ejs-radiobutton :label='$ts("Spectrum.ui_pt_spectrum5s")' name="cycle" value="2" ></ejs-radiobutton></div>
          <div class="row"><ejs-radiobutton :label='$ts("Spectrum.ui_pt_spectrum10s")' name="cycle" value="3"></ejs-radiobutton> </div>
      </form>
    </div>
  </div>
</div>
</template>
<script>
import Vue from 'vue';
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { RadioButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { enableRipple } from '@syncfusion/ej2-base';
import i18n from '../../../plugins/i18n.js';

enableRipple(true);
Vue.use(RadioButtonPlugin);

Vue.use(DropDownListPlugin);

export default {
  name: 'SpectrumAddTaskDialog',
  data() {
    return {
      durationValue: '3',
      items: [
        { durationVal: '0', durationTxt: this.$ts('Spectrum.ui_pt_spectrum1min') },
        { durationVal: '1', durationTxt: this.$ts('Spectrum.ui_pt_spectrum5min') },
        { durationVal: '2', durationTxt: this.$ts('Spectrum.ui_pt_spectrum10min') },
        { durationVal: '3', durationTxt: this.$ts('Spectrum.ui_pt_spectrum30min') },
        { durationVal: '4', durationTxt: this.$ts('Spectrum.ui_pt_spectrum1hour') },
        { durationVal: '5', durationTxt: this.$ts('Spectrum.ui_pt_spectrum4hour') },
        { durationVal: '6', durationTxt: this.$ts('Spectrum.ui_pt_spectrum1day') },
        { durationVal: '7', durationTxt: this.$ts('Spectrum.ui_pt_spectrum1week') }
      ],
      fields: { text: 'durationTxt', value: 'durationVal' },
      popupHeight: 200,
      currentIndex: 0
    };
  },
  methods: {
    $ts(args) {
      const mes = args.split('.');
      const result = (mes[0] && mes[1] && i18n.messages[i18n.locale][mes[0]][mes[1]]) ? i18n.messages[i18n.locale][mes[0]][mes[1]] : args;
      return result;
    },
    getData() {
      return {
        durationValue: this.durationValue
      };
    }
  }
};
</script>
